module.exports = __webpack_public_path__ + "static/media/g4.90c56df3.png";